import { render } from "./HomeWorkDetailPage.vue?vue&type=template&id=5d0013bb&scoped=true"
import script from "./HomeWorkDetailPage.vue?vue&type=script&lang=js"
export * from "./HomeWorkDetailPage.vue?vue&type=script&lang=js"

import "./HomeWorkDetailPage.vue?vue&type=style&index=0&id=5d0013bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0013bb"]])

export default __exports__